import { render, staticRenderFns } from "./organizational-chart.component.vue?vue&type=template&id=75a9dd4a&scoped=true&"
import script from "./organizational-chart.component.vue?vue&type=script&lang=ts&"
export * from "./organizational-chart.component.vue?vue&type=script&lang=ts&"
import style0 from "./organizational-chart.component.vue?vue&type=style&index=0&id=75a9dd4a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a9dd4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
